var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.16663 12.5002V20.8335C4.16663 21.386 4.38612 21.9159 4.77682 22.3066C5.16752 22.6973 5.69743 22.9168 6.24996 22.9168H18.75C19.3025 22.9168 19.8324 22.6973 20.2231 22.3066C20.6138 21.9159 20.8333 21.386 20.8333 20.8335V12.5002M16.6666 6.25016L12.5 2.0835M12.5 2.0835L8.33329 6.25016M12.5 2.0835V15.6252",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.910b34954d5303f1edc6b3ff70ba65b4.svg";
export { ForwardRef as ReactComponent };